export default __webpack_public_path__ + "static/media/grant.9b812a04.wav";